var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', _vm._b({
    staticClass: "main-section"
  }, 'section', _vm.$attrs, false), [this.$slots['mainSectionHead'] ? _vm._t("mainSectionHead") : _vm._e(), this.$slots['default'] ? _c('v-container', [_vm._t("default")], 2) : _vm._e(), this.$slots['mainSectionFoot'] ? _vm._t("mainSectionFoot") : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }